type CheckboxFieldProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const CheckboxField = ({
  label,
  checked,
  onChange,
}: CheckboxFieldProps) => (
  <label className="flex items-center gap-2 cursor-pointer">
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="size-4"
    />
    <span className="text-[#6b6b6b] text-[14px]">{label}</span>
  </label>
);